// utils/idValidators.js
import { isValidDominicanID } from './validateDominicanID'

export function isNationalIdInvalid(id, cfg) {
  if (!cfg) return false         // Sin configuración → nunca inválido

  const cleaned = id.replace(/\D/g, '')
  const { nationalIdLength, checksum, countryCode } = cfg

  // Si el país no tiene longitud definida, no se valida nada
  if (!nationalIdLength) return false

  const isShort    = cleaned.length < nationalIdLength
  const isTooLong  = cleaned.length > nationalIdLength

  let isChecksumInvalid = false
  if (checksum && cleaned.length === nationalIdLength) {
    switch (countryCode) {
      case 'DO':
        isChecksumInvalid = !isValidDominicanID(cleaned)
        break
      // Aquí se añaden más validadores por país cuando existan
      default:
        isChecksumInvalid = false
    }
  }

  return isShort || isTooLong || isChecksumInvalid
}
